export default defineNuxtPlugin(() => {
  const { isDev } = useRuntimeConfig().public
  const { configDynatraceUrl } = useFeatureFlags()
  if (configDynatraceUrl) {
    const { instance } = useScript<Window['dtrum']>(
      {
        src: configDynatraceUrl
      },
      {
        use: () => window.dtrum,
        trigger: 'server',
      }
    )

    return {
      provide: {
        dtrum: instance
      }
    }
  }
  else if (!isDev) {
    log.info('Dynatrace agentless Real User Monitoring(RUM) script is not injected.')
  }
})
